export default __webpack_public_path__ + "static/button_w.b1c72e6a5a4c5c3723c9e991ae8a4bb3.png";